
import type { PromotionTypeEnum } from '@empathybroker/tsclient-play/dist/enums/promotion-type.enum'
import type { PromotionTypeConfig } from '@empathybroker/tsclient-play/dist/models/instance/domains/tools/promotion-type-config'
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

import { EpbToggle } from '../shared/epb-toggle'

export default defineComponent({
  name: 'PromotionType',
  components: {
    EpbToggle,
  },
  props: {
    types: {
      type: Array as PropType<Array<PromotionTypeConfig>>,
      default: () => [],
    },
    value: {
      type: String,
      default: '',
    },
    disabled: Boolean,
    messages: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      baseClass: 'epb-promotion-type',
    }
  },
  computed: {
    toggleVisible(): boolean {
      return this.types.length > 1
    },
    toggleOptions(): { id: PromotionTypeEnum; content: string }[] {
      return this.types.map(({ id }) => {
        return {
          id,
          content: this.getValueLabel(id),
        }
      })
    },
  },
  methods: {
    onTypeChange(id: string): void {
      this.$emit('input', id)
    },
    getValueLabel(value: string): string {
      return (this.messages.values[value] ?? value).toUpperCase()
    },
  },
})
